import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SunDrenchedEleganceHero from "./sections/SunDrenchedEleganceHero";
import WhatDefinesUs from "./sections/WhatDefinesUs";
import MethodSection from "./sections/MethodSection";
import WorkplaceStress from "./sections/WorkplaceStress";
import WhatIsPsychologicalCounseling from "./sections/WhatIsPsychologicalCounseling";
import CounselingMenu from "./sections/CounselingMenu";
import LatestBlog from "./sections/LatestBlog";
import Faq from "./sections/Faq";
import OfficeLocations from "./sections/OfficeLocations";
import CallToAction from "./sections/CallToAction";
import AdminFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SunDrenchedEleganceHero />
      <WhatDefinesUs />
      <MethodSection />
      <WorkplaceStress />
      <WhatIsPsychologicalCounseling />
      <CounselingMenu />
      <LatestBlog />
      <Faq />
      <OfficeLocations />
      <CallToAction />
      <AdminFooter />
    </div>;
}